import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Section 1
	valueProp1Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-1-title',
		defaultMessage: 'Capture and prioritize',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp1Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-1-description',
		defaultMessage:
			'Gather and organize product ideas and customer insights from across the business in one place instead of disparate tools. Use criteria to make decisions and prioritize ideas based on customer and business impact.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 2
	valueProp2Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-2-title',
		defaultMessage: 'Engage',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp2Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-2-description',
		defaultMessage:
			'Spend less time persuading and updating by inviting key teams to contribute to insights and outcomes. Keep stakeholders and leadership informed and aligned on your product strategy with custom roadmaps.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 3
	valueProp3Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-3-title',
		defaultMessage: 'Connect',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp3DescriptionSpork: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-3-description-spork',
		defaultMessage:
			'Bridge the gap between business and tech teams by connecting your product ideas, with context, to the delivery work happening in Jira - the tool your developers already know and trust.',
		description: 'Description for section that explains more details about the value of template',
	},
	recommendedList1: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.recommended-list-1',
		defaultMessage: 'Product managers',
		description: 'Recommended project types to use this template',
	},
	recommendedList2: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-discovery.recommended-list-2',
		defaultMessage: 'Product teams',
		description: 'Recommended project types to use this template',
	},
});
